import React from "react"
import { Chip, Grid, Typography } from "@mui/material"
import useReportMultipleModalMultipleEdit from "Pages/ReportsAlerts/Reports/@hooks/multipleModalActions/useEditMultiple"
import { useComputed } from "@preact/signals-react"
import { reportListMultipleData } from "Pages/ReportsAlerts/Reports/@signals"
import { validateFormat } from "@utils"
import { TagFieldSeeker } from "@ui-seeker/core"


export default function ReportMultiModalEmailSection() {

	const { data, setData } = useReportMultipleModalMultipleEdit()

	return <Grid container spacing={2}>
		<Grid item xs={3} sx={{ borderBottom: "2px solid", borderColor: "primary.main" }}>
			<Typography variant="h5">Edit Multiple Emails:</Typography>
		</Grid>
		<Grid item xs={9}></Grid>
		<Grid item xs={6}>
			<TagFieldSeeker
				onChange={e => {
					if (e.every(e => validateFormat('email', e))) setData(e)
				}}
				value={data}
				label="Emails"
				placeholder="Press Enter for each email"
			/>
		</Grid>
		<Grid item xs={12}>
			<ReportMultiModalDatesDetails/>
		</Grid>
	</Grid>
}


function ReportMultiModalDatesDetails() {

	const reportsInfo = useComputed(() => reportListMultipleData.value.reportsInfo)

	return <Grid container spacing={2}>
		<Grid item xs={12}>
			<Typography variant="subtitle2">Affected reports:</Typography>
		</Grid>
		<Grid item xs={12} sx={{ maxWidth: "800px", overflowX: "auto", pb: 2 }}>
			<Grid container spacing={2}>
				{reportsInfo.value.map(({ name, notificationEmail }, idx) => {
					return <Grid
						item
						xs={12}
						key={`${name}-${idx}`}
						sx={{
							display: "flex",
							alignItems: "center",
							justifyContent: "start",
							gap: 1,
						}}>
						<Typography variant="subtitle2" color="secondary.light">{name}:</Typography>
						{notificationEmail?.map((value, idx) => <Chip
							key={`${value}-${idx}`}
							label={value}
						/>)}
					</Grid>
				})}
			</Grid>
		</Grid>
	</Grid>
}